var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 68,
    viewBox: "0 0 67 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_353_2154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5525 6.12348C56.1076 1.43871 50.7293 -1.04762 46.9082 1.68734C42.0533 5.15512 38.808 9.48656 33.4951 13.6348C38.808 17.783 42.0533 22.1145 46.9082 25.5823C50.7424 28.3172 56.1076 25.844 56.5525 21.1461C56.7881 18.6467 56.9059 16.1342 56.9189 13.6348C56.9189 11.1354 56.8012 8.62289 56.5525 6.12348Z",
    fill: "url(#paint0_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5525 9.66963C56.1076 7.19639 50.7293 5.8878 46.9082 7.32725C42.0533 9.15928 38.808 11.4362 33.4951 13.6216C38.808 15.8069 42.0533 18.097 46.9082 19.9159C50.7424 21.3554 56.1076 20.0468 56.5525 17.5735C56.7881 16.2519 56.9059 14.9302 56.9189 13.6085C56.9189 12.313 56.8012 10.9913 56.5525 9.66963Z",
    fill: "url(#paint1_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8047 8.4397L35.1963 15.035C39.5408 18.7514 42.5898 22.5071 46.9082 25.5823C50.2582 27.977 54.7859 26.3805 56.173 22.8081L41.8047 8.4397Z",
    fill: "url(#paint2_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9084 1.68725C46.5812 1.9228 46.2672 2.15835 45.9531 2.39389V24.8624C46.2672 25.098 46.5812 25.3466 46.9084 25.5691C50.7426 28.3041 56.1078 25.8308 56.5527 21.133C56.7883 18.6335 56.9061 16.121 56.9191 13.6216C56.9191 11.1222 56.8014 8.60971 56.5527 6.1103C56.1078 1.42553 50.7426 -1.04771 46.9084 1.68725Z",
    fill: "url(#paint3_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4377 6.12348C10.8826 1.43871 16.2609 -1.04762 20.082 1.68734C24.9369 5.15512 28.1822 9.48656 33.4951 13.6348C28.1822 17.783 24.9369 22.1145 20.082 25.5823C16.2479 28.3172 10.8826 25.844 10.4377 21.1461C10.1891 18.6467 10.0713 16.1342 10.0713 13.6348C10.0713 11.1354 10.1891 8.62289 10.4377 6.12348Z",
    fill: "url(#paint4_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4377 9.66963C10.8826 7.19639 16.2609 5.8878 20.082 7.32725C24.9369 9.15928 28.1822 11.4362 33.4951 13.6216C28.1822 15.8069 24.9369 18.097 20.082 19.9159C16.2479 21.3554 10.8826 20.0468 10.4377 17.5735C10.1891 16.278 10.0713 14.9564 10.0713 13.6347C10.0713 12.313 10.1891 10.9913 10.4377 9.66963Z",
    fill: "url(#paint5_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2965 12.4832C43.2965 12.4439 43.2965 12.4046 43.2965 12.3785C43.2965 12.3261 43.2965 12.2607 43.2965 12.2084C43.2965 9.1855 40.8494 6.75152 37.8397 6.75152C36.06 6.75152 34.4896 7.6021 33.482 8.9107C32.4875 7.6021 30.9041 6.75152 29.1244 6.75152C26.1277 6.73843 23.6807 9.1855 23.6807 12.1953V12.3654V12.4701C23.877 16.723 28.3523 21.0283 32.8801 23.423C33.2596 23.6193 33.7176 23.6193 34.0971 23.423C38.6379 21.0414 43.1133 16.7361 43.2965 12.4832Z",
    fill: "url(#paint6_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8523 17.6522C40.8661 17.6522 43.3092 15.2091 43.3092 12.1954C43.3092 9.18163 40.8661 6.73853 37.8523 6.73853C34.8386 6.73853 32.3955 9.18163 32.3955 12.1954C32.3955 15.2091 34.8386 17.6522 37.8523 17.6522Z",
    fill: "url(#paint7_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6807 12.1953V12.3654V12.4701C23.877 16.723 28.3523 21.0283 32.8801 23.423C33.2596 23.6193 33.7176 23.6193 34.0971 23.423C38.6248 21.0283 43.1002 16.723 43.2965 12.4701C43.2965 12.4309 43.2965 12.3916 43.2965 12.3654C43.2965 12.3131 43.2965 12.2477 43.2965 12.1953H23.6807Z",
    fill: "url(#paint8_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3092 12.1953V12.3654V12.4701C43.1129 16.723 38.6375 21.0283 34.1098 23.423C33.7303 23.6193 33.2723 23.6193 32.8928 23.423C28.365 21.0283 23.8896 16.723 23.6934 12.4701C23.6934 12.4309 23.6934 12.3916 23.6934 12.3654C23.6934 12.3131 23.6934 12.2477 23.6934 12.1953H43.3092Z",
    fill: "url(#paint9_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3092 12.1953V12.3654V12.4701C43.1129 16.723 38.6375 21.0283 34.1098 23.423C33.7303 23.6193 33.2723 23.6193 32.8928 23.423C28.365 21.0283 23.8896 16.723 23.6934 12.4701C23.6934 12.4309 23.6934 12.3916 23.6934 12.3654C23.6934 12.3131 23.6934 12.2477 23.6934 12.1953H43.3092Z",
    fill: "url(#paint10_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3828 12.1954C32.3828 13.4385 32.8016 14.577 33.4951 15.493C32.5006 16.8016 30.9172 17.6522 29.1375 17.6522C26.1146 17.6522 23.6807 15.2051 23.6807 12.1954C23.6807 9.17251 26.1277 6.73853 29.1375 6.73853C30.9172 6.73853 32.4875 7.58911 33.4951 8.89771C32.8016 9.81372 32.3828 10.9653 32.3828 12.1954Z",
    fill: "url(#paint11_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.47988 32.8057H59.5227V62.393C59.5227 64.3951 57.9 66.0309 55.8848 66.0309H11.1047C9.10254 66.0309 7.4668 64.4082 7.4668 62.393V32.8057H7.47988Z",
    fill: "url(#paint12_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.47949 32.8057H59.5223V48.9145H7.47949V32.8057Z",
    fill: "url(#paint13_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5096 51.2568V62.393C59.5096 64.3951 57.8869 66.0309 55.8717 66.0309H11.1047C9.10254 66.0309 7.4668 64.4082 7.4668 62.393V51.2568H59.5096Z",
    fill: "url(#paint14_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5092 32.8057H37.3154V66.0309H55.8844C57.8865 66.0309 59.5223 64.4082 59.5223 62.393V32.8057H59.5092Z",
    fill: "url(#paint15_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5092 32.8057H37.3154V66.0309H55.8844C57.8865 66.0309 59.5223 64.4082 59.5223 62.393V32.8057H59.5092Z",
    fill: "url(#paint16_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16074 18.7122H58.8295C61.0934 18.7122 62.9385 20.5573 62.9385 22.8211V30.5157C62.9385 32.7795 61.0934 34.6247 58.8295 34.6247H8.16074C5.89688 34.6247 4.05176 32.7926 4.05176 30.5157V22.8211C4.05176 20.5573 5.89688 18.7122 8.16074 18.7122Z",
    fill: "url(#paint17_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9385 23.4099V30.5156C62.9385 32.7794 61.0934 34.6246 58.8295 34.6246H8.16074C5.89688 34.6246 4.05176 32.7925 4.05176 30.5156V23.4099H62.9385Z",
    fill: "url(#paint18_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8295 18.7122H37.8135V34.6247H58.8164C61.0803 34.6247 62.9254 32.7795 62.9254 30.5157V22.8211C62.9385 20.5573 61.0934 18.7122 58.8295 18.7122Z",
    fill: "url(#paint19_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8295 18.7122H37.8135V34.6247H58.8164C61.0803 34.6247 62.9254 32.7795 62.9254 30.5157V22.8211C62.9385 20.5573 61.0934 18.7122 58.8295 18.7122Z",
    fill: "url(#paint20_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0984 21.1199V63.623C41.0984 65.7953 39.3449 67.5488 37.1727 67.5488H29.8184C27.6461 67.5488 25.8926 65.7953 25.8926 63.623V21.1199C25.8926 18.9476 27.6461 17.1941 29.8184 17.1941H37.1727C39.3449 17.1941 41.0984 18.9476 41.0984 21.1199Z",
    fill: "url(#paint21_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3809 67.5488H37.1725C39.3447 67.5488 41.0982 65.7953 41.0982 63.623V21.1199C41.0982 18.9476 39.3447 17.1941 37.1725 17.1941H30.3809V67.5488Z",
    fill: "url(#paint22_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8926 34.6245H41.0984V48.9144H25.8926V34.6245Z",
    fill: "url(#paint23_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8926 63.623V51.2568H41.0984V63.623C41.0984 65.7953 39.3449 67.5488 37.1727 67.5488H29.8184C27.6461 67.5488 25.8926 65.7953 25.8926 63.623Z",
    fill: "url(#paint24_linear_353_2154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0984 21.1199V34.6246H25.8926V21.1199C25.8926 18.9476 27.6461 17.1941 29.8184 17.1941H37.1727C39.3449 17.1941 41.0984 18.9476 41.0984 21.1199Z",
    fill: "url(#paint25_linear_353_2154)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_353_2154",
    x1: 42.5747,
    y1: 5.33034,
    x2: 51.3436,
    y2: 19.3854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB4BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#FDAFB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3798,
    stopColor: "#FDA3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5761,
    stopColor: "#FD8E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7747,
    stopColor: "#FD717C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    stopColor: "#FD4C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD4755"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_353_2154",
    x1: 45.4784,
    y1: 12.522,
    x2: 42.4933,
    y2: 6.27174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1276,
    stopColor: "#FC4654",
    stopOpacity: 0.018
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#FB4452",
    stopOpacity: 0.073
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3944,
    stopColor: "#F8404E",
    stopOpacity: 0.164
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5304,
    stopColor: "#F53B49",
    stopOpacity: 0.292
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6676,
    stopColor: "#F13442",
    stopOpacity: 0.456
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8059,
    stopColor: "#EC2C3A",
    stopOpacity: 0.657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9424,
    stopColor: "#E62331",
    stopOpacity: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_353_2154",
    x1: 50.4651,
    y1: 18.9304,
    x2: 39.9216,
    y2: 15.9392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1276,
    stopColor: "#FC4654",
    stopOpacity: 0.018
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#FB4452",
    stopOpacity: 0.073
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3944,
    stopColor: "#F8404E",
    stopOpacity: 0.164
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5304,
    stopColor: "#F53B49",
    stopOpacity: 0.292
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6676,
    stopColor: "#F13442",
    stopOpacity: 0.456
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8059,
    stopColor: "#EC2C3A",
    stopOpacity: 0.657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9424,
    stopColor: "#E62331",
    stopOpacity: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_353_2154",
    x1: 52.6659,
    y1: 13.6347,
    x2: 57.4817,
    y2: 13.6347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1276,
    stopColor: "#FC4654",
    stopOpacity: 0.018
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#FB4452",
    stopOpacity: 0.073
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3944,
    stopColor: "#F8404E",
    stopOpacity: 0.164
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5304,
    stopColor: "#F53B49",
    stopOpacity: 0.292
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6676,
    stopColor: "#F13442",
    stopOpacity: 0.456
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8059,
    stopColor: "#EC2C3A",
    stopOpacity: 0.657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9424,
    stopColor: "#E62331",
    stopOpacity: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_353_2154",
    x1: 16.7035,
    y1: 4.01546,
    x2: 22.6737,
    y2: 19.5631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB4BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#FDAFB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3798,
    stopColor: "#FDA3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5761,
    stopColor: "#FD8E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7747,
    stopColor: "#FD717C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    stopColor: "#FD4C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD4755"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_353_2154",
    x1: 21.5119,
    y1: 12.522,
    x2: 24.497,
    y2: 6.27174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1276,
    stopColor: "#FC4654",
    stopOpacity: 0.018
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#FB4452",
    stopOpacity: 0.073
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3944,
    stopColor: "#F8404E",
    stopOpacity: 0.164
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5304,
    stopColor: "#F53B49",
    stopOpacity: 0.292
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6676,
    stopColor: "#F13442",
    stopOpacity: 0.456
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8059,
    stopColor: "#EC2C3A",
    stopOpacity: 0.657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9424,
    stopColor: "#E62331",
    stopOpacity: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_353_2154",
    x1: 28.0071,
    y1: 7.3379,
    x2: 39.2281,
    y2: 18.5588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB4BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#FDAFB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3798,
    stopColor: "#FDA3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5761,
    stopColor: "#FD8E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7747,
    stopColor: "#FD717C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    stopColor: "#FD4C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD4755"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_353_2154",
    x1: 35.6289,
    y1: 10.4331,
    x2: 33.6329,
    y2: 8.84261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB4BA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1209,
    stopColor: "#FDB4BA",
    stopOpacity: 0.016
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2464,
    stopColor: "#FDB4BA",
    stopOpacity: 0.066
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3739,
    stopColor: "#FDB4BA",
    stopOpacity: 0.148
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5029,
    stopColor: "#FDB4BA",
    stopOpacity: 0.263
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6329,
    stopColor: "#FDB4BA",
    stopOpacity: 0.411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#FDB4BA",
    stopOpacity: 0.593
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8933,
    stopColor: "#FDB4BA",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB4BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_353_2154",
    x1: 36.489,
    y1: 17.989,
    x2: 38.2355,
    y2: 20.7334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1276,
    stopColor: "#FC4654",
    stopOpacity: 0.018
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#FB4452",
    stopOpacity: 0.073
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3944,
    stopColor: "#F8404E",
    stopOpacity: 0.164
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5304,
    stopColor: "#F53B49",
    stopOpacity: 0.292
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6676,
    stopColor: "#F13442",
    stopOpacity: 0.456
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8059,
    stopColor: "#EC2C3A",
    stopOpacity: 0.657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9424,
    stopColor: "#E62331",
    stopOpacity: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_353_2154",
    x1: 29.9333,
    y1: 18.8809,
    x2: 28.1868,
    y2: 21.6253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1276,
    stopColor: "#FC4654",
    stopOpacity: 0.018
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#FB4452",
    stopOpacity: 0.073
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3944,
    stopColor: "#F8404E",
    stopOpacity: 0.164
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5304,
    stopColor: "#F53B49",
    stopOpacity: 0.292
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6676,
    stopColor: "#F13442",
    stopOpacity: 0.456
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8059,
    stopColor: "#EC2C3A",
    stopOpacity: 0.657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9424,
    stopColor: "#E62331",
    stopOpacity: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_353_2154",
    x1: 37.4858,
    y1: 19.0378,
    x2: 38.7489,
    y2: 20.8154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB4BA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1209,
    stopColor: "#FDB4BA",
    stopOpacity: 0.016
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2464,
    stopColor: "#FDB4BA",
    stopOpacity: 0.066
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3739,
    stopColor: "#FDB4BA",
    stopOpacity: 0.148
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5029,
    stopColor: "#FDB4BA",
    stopOpacity: 0.263
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6329,
    stopColor: "#FDB4BA",
    stopOpacity: 0.411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#FDB4BA",
    stopOpacity: 0.593
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8933,
    stopColor: "#FDB4BA",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB4BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_353_2154",
    x1: 31.2505,
    y1: 10.0934,
    x2: 33.5174,
    y2: 7.82636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1276,
    stopColor: "#FC4654",
    stopOpacity: 0.018
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#FB4452",
    stopOpacity: 0.073
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3944,
    stopColor: "#F8404E",
    stopOpacity: 0.164
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5304,
    stopColor: "#F53B49",
    stopOpacity: 0.292
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6676,
    stopColor: "#F13442",
    stopOpacity: 0.456
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8059,
    stopColor: "#EC2C3A",
    stopOpacity: 0.657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9424,
    stopColor: "#E62331",
    stopOpacity: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_353_2154",
    x1: 27.379,
    y1: 33.5322,
    x2: 40.1828,
    y2: 63.7598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2FAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1386,
    stopColor: "#BDF9E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2824,
    stopColor: "#B1F9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4285,
    stopColor: "#9CF8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5763,
    stopColor: "#7FF7CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    stopColor: "#5AF5C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8732,
    stopColor: "#2CF3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F2A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_353_2154",
    x1: 33.4945,
    y1: 41.9678,
    x2: 33.4945,
    y2: 34.2066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C285",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1386,
    stopColor: "#00C285",
    stopOpacity: 0.021
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2824,
    stopColor: "#00C285",
    stopOpacity: 0.086
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4285,
    stopColor: "#00C285",
    stopOpacity: 0.193
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5763,
    stopColor: "#00C285",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    stopColor: "#00C285",
    stopOpacity: 0.536
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8732,
    stopColor: "#00C285",
    stopOpacity: 0.768
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C285"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_353_2154",
    x1: 33.4947,
    y1: 60.0722,
    x2: 33.4947,
    y2: 66.0778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C285",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1386,
    stopColor: "#00C285",
    stopOpacity: 0.021
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2824,
    stopColor: "#00C285",
    stopOpacity: 0.086
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4285,
    stopColor: "#00C285",
    stopOpacity: 0.193
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5763,
    stopColor: "#00C285",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    stopColor: "#00C285",
    stopOpacity: 0.536
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8732,
    stopColor: "#00C285",
    stopOpacity: 0.768
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C285"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_353_2154",
    x1: 54.6093,
    y1: 49.4173,
    x2: 59.6987,
    y2: 49.4173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C285",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1386,
    stopColor: "#00C285",
    stopOpacity: 0.021
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2824,
    stopColor: "#00C285",
    stopOpacity: 0.086
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4285,
    stopColor: "#00C285",
    stopOpacity: 0.193
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5763,
    stopColor: "#00C285",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    stopColor: "#00C285",
    stopOpacity: 0.536
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8732,
    stopColor: "#00C285",
    stopOpacity: 0.768
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C285"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_353_2154",
    x1: 46.9651,
    y1: 49.4173,
    x2: 40.7379,
    y2: 49.4173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C285",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1386,
    stopColor: "#00C285",
    stopOpacity: 0.021
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2824,
    stopColor: "#00C285",
    stopOpacity: 0.086
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4285,
    stopColor: "#00C285",
    stopOpacity: 0.193
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5763,
    stopColor: "#00C285",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    stopColor: "#00C285",
    stopOpacity: 0.536
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8732,
    stopColor: "#00C285",
    stopOpacity: 0.768
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C285"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_353_2154",
    x1: 33.4952,
    y1: 18.8765,
    x2: 33.4952,
    y2: 35.2184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2FAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1386,
    stopColor: "#BDF9E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2824,
    stopColor: "#B1F9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4285,
    stopColor: "#9CF8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5763,
    stopColor: "#7FF7CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    stopColor: "#5AF5C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8732,
    stopColor: "#2CF3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F2A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_353_2154",
    x1: 33.4951,
    y1: 30.1574,
    x2: 33.4951,
    y2: 34.7553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C285",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1386,
    stopColor: "#00C285",
    stopOpacity: 0.021
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2824,
    stopColor: "#00C285",
    stopOpacity: 0.086
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4285,
    stopColor: "#00C285",
    stopOpacity: 0.193
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5763,
    stopColor: "#00C285",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    stopColor: "#00C285",
    stopOpacity: 0.536
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8732,
    stopColor: "#00C285",
    stopOpacity: 0.768
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C285"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_353_2154",
    x1: 57.3883,
    y1: 26.6689,
    x2: 63.1473,
    y2: 26.6689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C285",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1386,
    stopColor: "#00C285",
    stopOpacity: 0.021
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2824,
    stopColor: "#00C285",
    stopOpacity: 0.086
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4285,
    stopColor: "#00C285",
    stopOpacity: 0.193
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5763,
    stopColor: "#00C285",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    stopColor: "#00C285",
    stopOpacity: 0.536
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8732,
    stopColor: "#00C285",
    stopOpacity: 0.768
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C285"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_353_2154",
    x1: 46.4061,
    y1: 26.6689,
    x2: 40.0627,
    y2: 26.6689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C285",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1386,
    stopColor: "#00C285",
    stopOpacity: 0.021
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2824,
    stopColor: "#00C285",
    stopOpacity: 0.086
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4285,
    stopColor: "#00C285",
    stopOpacity: 0.193
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5763,
    stopColor: "#00C285",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    stopColor: "#00C285",
    stopOpacity: 0.536
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8732,
    stopColor: "#00C285",
    stopOpacity: 0.768
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C285"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_353_2154",
    x1: 26.0497,
    y1: 42.3701,
    x2: 41.6653,
    y2: 42.3701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB4BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#FDAFB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3798,
    stopColor: "#FDA3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5761,
    stopColor: "#FD8E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7747,
    stopColor: "#FD717C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    stopColor: "#FD4C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD4755"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_353_2154",
    x1: 37.2643,
    y1: 42.3697,
    x2: 41.0375,
    y2: 42.3697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1276,
    stopColor: "#FC4654",
    stopOpacity: 0.018
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#FB4452",
    stopOpacity: 0.073
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3944,
    stopColor: "#F8404E",
    stopOpacity: 0.164
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5304,
    stopColor: "#F53B49",
    stopOpacity: 0.292
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6676,
    stopColor: "#F13442",
    stopOpacity: 0.456
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8059,
    stopColor: "#EC2C3A",
    stopOpacity: 0.657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9424,
    stopColor: "#E62331",
    stopOpacity: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_353_2154",
    x1: 33.4955,
    y1: 41.5861,
    x2: 33.4955,
    y2: 34.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1276,
    stopColor: "#FC4654",
    stopOpacity: 0.018
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#FB4452",
    stopOpacity: 0.073
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3944,
    stopColor: "#F8404E",
    stopOpacity: 0.164
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5304,
    stopColor: "#F53B49",
    stopOpacity: 0.292
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6676,
    stopColor: "#F13442",
    stopOpacity: 0.456
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8059,
    stopColor: "#EC2C3A",
    stopOpacity: 0.657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9424,
    stopColor: "#E62331",
    stopOpacity: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_353_2154",
    x1: 33.4954,
    y1: 63.9485,
    x2: 33.4954,
    y2: 67.6841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1276,
    stopColor: "#FC4654",
    stopOpacity: 0.018
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#FB4452",
    stopOpacity: 0.073
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3944,
    stopColor: "#F8404E",
    stopOpacity: 0.164
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5304,
    stopColor: "#F53B49",
    stopOpacity: 0.292
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6676,
    stopColor: "#F13442",
    stopOpacity: 0.456
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8059,
    stopColor: "#EC2C3A",
    stopOpacity: 0.657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9424,
    stopColor: "#E62331",
    stopOpacity: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_353_2154",
    x1: 33.4955,
    y1: 29.9565,
    x2: 33.4955,
    y2: 35.8024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1276,
    stopColor: "#FC4654",
    stopOpacity: 0.018
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#FB4452",
    stopOpacity: 0.073
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3944,
    stopColor: "#F8404E",
    stopOpacity: 0.164
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5304,
    stopColor: "#F53B49",
    stopOpacity: 0.292
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6676,
    stopColor: "#F13442",
    stopOpacity: 0.456
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8059,
    stopColor: "#EC2C3A",
    stopOpacity: 0.657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9424,
    stopColor: "#E62331",
    stopOpacity: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F2D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_353_2154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    fill: "white",
    transform: "translate(-0.00488281 0.548828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/Gift.34972372813965392188ccc0d24b60a6.svg";
export { ForwardRef as ReactComponent };